// extracted by mini-css-extract-plugin
export var header = "Header-module--header--AWpe5";
export var tabulaGamesLogo = "Header-module--tabulaGamesLogo--1-0Vu";
export var tabulaGamesLogoImage = "Header-module--tabulaGamesLogoImage--2_8pn";
export var tabulaRoadmapBrand = "Header-module--tabulaRoadmapBrand--2JlPz";
export var tabulaRoadmapDescription = "Header-module--tabulaRoadmapDescription--2sFgY";